import FolderForm from './FolderForm';

export default FolderForm;
